import {User} from '@features/user/types'

/** True when the freelancer can only be assigned reviews (no Home Consultant or Creator role). */
export const isReviewerOnly = (user: Pick<User, 'isReviewer' | 'isInspector' | 'isCreator'>): boolean =>
    !!user.isReviewer && !user.isInspector && !user.isCreator
